<template>
  <div
    v-if="display_flg"
    :value="value"
    class="component-datepicker-calendar"
    :class="{ 'calendar-absolute' : inline === false }"
    :style="add_style"
  >
    <div class="header">
      <p class="calendar-button prev" :disabled="prev_button_check" @click="next_prev_click(-1)"/>
      <p
        :class="{ 'small-font-size-p' : height <= 230, 'large-font-size-p' : height >= 400 }"
        class="calendar-title"
      >{{ select_year }}{{ $t('year') }}{{ zero_pad(select_month) }}{{ $t('month') }}</p>
      <p class="calendar-button next" :disabled="next_button_check" @click="next_prev_click(1)"/>
    </div>
    <table>
      <thead>
        <tr>
          <td>{{ $t('sun') }}</td>
          <td>{{ $t('mon') }}</td>
          <td>{{ $t('tue') }}</td>
          <td>{{ $t('wed') }}</td>
          <td>{{ $t('thu') }}</td>
          <td>{{ $t('fri') }}</td>
          <td>{{ $t('sat') }}</td>
        </tr>
      </thead>
      <tbody>
        <template  v-for="(item, index) in date_arr">
          <tr  v-if="index === 0 || item[0] !== ''" :key="index">
            <td v-for="(obj, date_index) in item"
              :key="date_index"
              :class="{ 'before-next-month' : before_next_month_check(obj.date_obj),
                'selected-date' : selected_date_check(obj.date_obj),
                'holiday': holiday_check(obj.date_obj),
                'sun' : date_index === 0,
                'sat' : date_index === 6 }"
              :disabled="disable_chack(obj.date_obj)"
              @click="date_click(obj.date_obj)"
            >
              <p
                :class="{ 'small-font-size-p' : height <= 230, 'large-font-size-p' : height >= 400, 'today' : today_check(obj.date_obj) }"
                class="date"
                >{{ obj.date }}</p>
              <div class="schedule-container">
                <p
                  class="schedule"
                  :class="{ 'contain' : schedule_get(obj.date_obj) !== '', 'end' : schedule_end(obj.date_obj) }"
                >{{ schedule_get(obj.date_obj) }}</p>
              </div>
            </td>
          </tr>
        </template>
      </tbody>
    </table>
  </div>
</template>

<script>

export default {
  name: 'DatepickerCalendar',
  // ===========================================================================
  // language
  // ===========================================================================
  language: {
    'ja': {
      'year': '年',
      'month': '月',
      'day': '日',
      'sun': '日',
      'mon': '月',
      'tue': '火',
      'wed': '水',
      'thu': '木',
      'fri': '金',
      'sat': '土',
    },
    'en': {
      'year': 'year',
      'month': 'month',
      'day': 'day',
      'sun': 'sun',
      'mon': 'mon',
      'tue': 'tue',
      'wed': 'wed',
      'thu': 'thu',
      'fri': 'fri',
      'sat': 'sat',
    }
  },
  // ===========================================================================
  // Props
  // ===========================================================================
  props: {
    value: {
      type: [String, Date],
      required: false,
      default: () => {
        return new Date();
      }
    },
    display: {
      type: Boolean,
      required: false,
      default: false
    },
    inline: {
      type: Boolean,
      required: false,
      default: false
    },
    format: {
      type: String,
      required: false,
      default: 'YYYY/MM/DD'
    },
    width: {
      type: Number,
      required: false,
      default: null
    },
    height: {
      type: Number,
      required: false,
      default: null
    },
    effective_dates_period: {
      type: Object,
      required: false,
      default: () => {
        const obj = new Object();
        obj.to = null;
        obj.from = null;
        return obj;
      }
    },
    disable_dates: {
      type: Array,
      required: false,
      default: () => {
        const arr = new Array();
        return arr;
      }
    },
    holidays: {
      type: Array,
      required: false,
      default: () => {
        // dateオブジェクト,または文字列(YYYYMMDD)
        return new Array();
      }
    },
    // 予定
    schedules: {
      type: Object,
      required: false,
      default: () => {
        return {};
      }
    }
  },
  // ===========================================================================
  // Computed
  // ===========================================================================
  computed: {
    // value: {
    //   get() {
    //     if (!this.value) {
    //       return this.date_format(new Date());
    //     }
    //     return this.date_format(this.value);
    //   },
    //   set(value) {
    //     this.$emit('update:value', value);
    //   }
    // },
    display_flg: {
      get() {
        if (this.inline) {
          return true;
        }
        return this.display;
      },
      set(value) {
        this.$emit('update:display', value);
      }
    },
    add_style () {
      let style = (this.width !== null) ? `width: ${this.width}px;` : '';
      style += (this.height !== null) ? `height: ${this.height}px;` : '';
      return style;
    },
    date_arr () {
      if (this.start_date === null) {
        return [];
      }
      let week_numm = this.start_date.getDay();
      let i, j;
      let res_arr = [];
      let counter = 0;
      let tmp_date_obj;
      let tmp_data;

      for (i = 0; i < 6; i++) {
        res_arr[i] = [];
        for (j = 0; j < 7; j++) {
          // 先月の日付
          if (i === 0 && week_numm > j) {
            tmp_date_obj = this.first_date_obj();
            tmp_date_obj.setDate((-1) * (week_numm - j - 1));

            tmp_data = new Object();
            tmp_data.date_obj = tmp_date_obj;
            tmp_data.date = tmp_date_obj.getDate();

            res_arr[i].push(tmp_data);
            continue;
          }
          counter++;
          // 来月の日付
          if (counter > this.end_date.getDate()) {
            tmp_date_obj = this.first_date_obj();
            tmp_date_obj.setDate(counter);

            tmp_data = new Object();
            tmp_data.date_obj = tmp_date_obj;
            tmp_data.date = tmp_date_obj.getDate();

            res_arr[i].push(tmp_data);
            continue;
          }
          // 今月の日付
          tmp_date_obj = this.first_date_obj();
          tmp_date_obj.setDate(counter);

          tmp_data = new Object();
          tmp_data.date_obj = tmp_date_obj;
          tmp_data.date = tmp_date_obj.getDate();

          res_arr[i].push(tmp_data);
        }
      }
      return res_arr;
    },
    start_date() {
      // 1日のdate
      let date_obj = this.first_date_obj();
      let start_date_obj = new Date(
        date_obj.getFullYear(),
        date_obj.getMonth(),
        1
      );
      return start_date_obj;
    },
    end_date () {
      // 末日のdate
      let date_obj = this.first_date_obj();
      let end_date_obj = new Date(
        date_obj.getFullYear(),
        date_obj.getMonth() + 1,
        0
      );
      return end_date_obj;
    },
    prev_button_check () {
      let start_date_obj = this.start_date;
      let effective_dates_from = this.effective_dates_period.from;
      let start_ym, effective_dates_from_ym;
      if (effective_dates_from === null || effective_dates_from === '') {
        return false;
      }
      if (typeof effective_dates_from === 'string') {
        effective_dates_from_ym = effective_dates_from.substr(0, 6);
      } else {
        effective_dates_from_ym =
          String(effective_dates_from.getFullYear()) +
          this.zero_pad(effective_dates_from.getMonth() + 1);
      }
      start_ym =
        String(start_date_obj.getFullYear()) +
        this.zero_pad(start_date_obj.getMonth() + 1);
      if (start_ym <= effective_dates_from_ym) {
        return true;
      }
      return false;
    },
    next_button_check () {
      let start_date_obj = this.start_date;
      let effective_dates_to = this.effective_dates_period.to;
      let start_ym, effective_dates_to_ym;
      if (effective_dates_to === null || effective_dates_to === '') {
        return false;
      }
      if (typeof effective_dates_to === 'string') {
        effective_dates_to_ym = effective_dates_to.substr(0, 6);
      } else {
        effective_dates_to_ym =
          String(effective_dates_to.getFullYear()) +
          this.zero_pad(effective_dates_to.getMonth() + 1);
      }
      start_ym =
        String(start_date_obj.getFullYear()) +
        this.zero_pad(start_date_obj.getMonth() + 1);
      if (start_ym >= effective_dates_to_ym) {
        return true;
      }
      return false;
    }
  },
  // ===========================================================================
  // Data
  // ===========================================================================
  data () {
    return {
      select_date_obj: null,
      select_year: '',
      select_month: '',
      selected_date: '',
      timer: null
    };
  },
  // ===========================================================================
  // Created
  // ===========================================================================
  created() {
    // 言語対応
    // this.$t = this.$options.language.ja;

    this.set_select_date();
  },
  // ===========================================================================
  // Watch
  // ===========================================================================
  watch: {
    value: function() {
      this.set_select_date();
      if (this.value === '') {
        this.$emit('update_date_obj', '');
        // this.$emit('update_format', '');
      } else {
        this.$emit('update_date_obj', this.value);
        // this.$emit('update_format', this.date_format(this.value));
      }
    }
  },
  // ===========================================================================
  // Methods
  // ===========================================================================
  methods: {
    today_check (check_date_obj) {
      if (this.date_format_yyyymmdd(check_date_obj) === this.date_format_yyyymmdd(new Date())) {
        return true;
      }
      return false;
    },
    set_select_date () {
      // 年月の設定
      let tmp_date_obj;
      if (this.value === '') {
        tmp_date_obj = new Date();
      } else {
        tmp_date_obj = this.value;
      }
      const select_date_obj = this.convert_date_obj_from_value(this.date_format(tmp_date_obj));
      this.select_year = select_date_obj.getFullYear();
      this.select_month = select_date_obj.getMonth() + 1;
      this.select_date_obj = select_date_obj;
    },
    first_date_obj () {
      return new Date(this.select_year, this.select_month -1, 1);
    },
    convert_date_obj_from_value (date_value) {
      let set_year, set_month, set_date;
      if (!!date_value === false) {
        return new Date();
      }
      let result;
      let reg_exp_year = '(\\d{4})';
      let reg_exp_month = '(\\d{2})';
      let reg_exp_date = '(\\d{2})';
      let reg_exp_week = '.+';
      let format = this.format;
      let year_index = format.indexOf('YYYY');
      let month_index = format.indexOf('MM');
      let date_index = format.indexOf('DD');
      let index_arr = [year_index, month_index, date_index];
      // YYYY MM DDそれぞれの順番を取得する
      index_arr.sort(function (a, b) {
        if( a < b ) return -1;
        if( a > b ) return 1;
        return 0;
      });
      // エスケープ
      format = format.replace('\\', '\\\\');
      format = format.replace('.', '\\.');
      format = format.replace('|', '\\|');
      format = format.replace('^', '\\^');
      format = format.replace('$', '\\$');
      format = format.replace('+', '\\+');
      format = format.replace('*', '\\*');
      format = format.replace('(', '\\(');
      format = format.replace(')', '\\)');
      format = format.replace('[', '\\[');
      format = format.replace(']', '\\]');
      format = format.replace('{', '\\{');
      format = format.replace('}', '\\}');
      // 検索
      format = format.replace('YYYY', reg_exp_year);
      format = format.replace('MM', reg_exp_month);
      format = format.replace('DD', reg_exp_date);
      format = format.replace('W', reg_exp_week);
      result = date_value.match(new RegExp(format));
      // console.log(format);
      if (!result) {
        return new Date();
      }
      set_year = parseInt(result[index_arr.indexOf(year_index) + 1], 10);
      set_month = parseInt(result[index_arr.indexOf(month_index) + 1], 10);
      set_date = parseInt(result[index_arr.indexOf(date_index) + 1], 10);

      return new Date(set_year, set_month - 1, set_date);

      // ieで名前付きキャプチャが使用できない
      // let result;
      // let reg_exp_year = '(?<year>\\d{4})';
      // let reg_exp_month = '(?<month>\\d{2})';
      // let reg_exp_date = '(?<date>\\d{2})';
      // let reg_exp_week = '(?<week>\.)';
      // let format = this.format;
      //
      // format = format.replace('YYYY', reg_exp_year);
      // format = format.replace('MM', reg_exp_month);
      // format = format.replace('DD', reg_exp_date);
      // format = format.replace('W', reg_exp_week);
      // result = date_value.match(new RegExp(format));
      // if (!result) {
      //   return new Date();
      // }
      // set_year = parseInt(result.groups.year, 10);
      // set_month = parseInt(result.groups.month, 10);
      // set_date = parseInt(result.groups.date, 10);
      //
      // return new Date(set_year, set_month - 1, set_date);
    },
    before_next_month_check (check_date_obj) {
      let year = check_date_obj.getFullYear();
      let month = check_date_obj.getMonth() + 1;
      return !(this.select_year === year && this.select_month === month);
    },
    selected_date_check (check_date_obj) {
      if (this.value === '') {
        return false;
      }
      return this.date_format(check_date_obj) === this.date_format(this.value);
    },
    holiday_check (check_date_obj) {
      const holidays = this.holidays;
      const len = holidays.length;
      let i, tmp_date;
      for (i = 0; i < len; i++) {
        if (typeof holidays[i] === 'string') {
          tmp_date = holidays[i];
        } else {
          tmp_date = this.date_format_yyyymmdd(holidays[i]);
        }
        if (this.date_format_yyyymmdd(check_date_obj) === tmp_date) {
          return true;
        }
      }
      return false;
    },
    disable_chack (check_date_obj) {
      let result = false;
      // 有効期間
      let effective_dates_from = this.effective_dates_period.from;
      let effective_dates_to = this.effective_dates_period.to;
      // 無効日付配列
      const disable_dates = this.disable_dates;
      const disable_dates_length = disable_dates.length;
      // チェック対象日
      const check_date = String(check_date_obj.getFullYear()) +
        this.zero_pad(check_date_obj.getMonth() + 1) +
        this.zero_pad(check_date_obj.getDate());
      let i, tmp_date, to_date, from_date;

      // 有効日チェック
      if (effective_dates_to === '') {
        effective_dates_to = null;
      }
      if (effective_dates_from === '') {
        effective_dates_from = null;
      }
      if (effective_dates_to !== null || effective_dates_from !== null) {
        // start
        if (effective_dates_to !== null) {
          if (typeof effective_dates_to === 'string') {
            to_date = effective_dates_to;
          } else {
            to_date = this.date_format_yyyymmdd(effective_dates_to);
          }
        }
        // end
        if (effective_dates_from !== null) {
          if (typeof effective_dates_from === 'string') {
            from_date = effective_dates_from;
          } else {
            from_date = this.date_format_yyyymmdd(effective_dates_from);
          }
        }
        // チェック
        if (effective_dates_to !== null && effective_dates_from !== null) {
          result = (from_date > check_date || to_date < check_date);
        } else if (effective_dates_to !== null) {
          result = to_date < check_date;
        } else {
          result = from_date > check_date;
        }
      }
      // 無効日付チェック
      for (i = 0; i < disable_dates_length; i++) {
        if (typeof disable_dates[i] === 'string') {
          tmp_date = disable_dates[i];
        } else {
          tmp_date = this.date_format_yyyymmdd(disable_dates[i]);
        }
        if (check_date === tmp_date) {
          result = true;
          break;
        }
      }
      return result;
    },
    next_prev_click (num) {
      this.select_date_obj.setMonth(this.select_date_obj.getMonth() + num);
      // 年月の設定
      this.select_year = this.select_date_obj.getFullYear();
      this.select_month = this.select_date_obj.getMonth() + 1;
      this.$emit('changed_month', String(this.select_year) + this.zero_pad(this.select_month));
    },
    date_click (date_obj) {
      if (this.disable_chack(date_obj) === true) {
        return;
      }
      // 年月の設定
      this.select_year = date_obj.getFullYear();
      this.select_month = date_obj.getMonth() + 1;

      this.selected_date = date_obj.getFullYear() +
        this.zero_pad(date_obj.getMonth()) +
        this.zero_pad(date_obj.getDate());

      this.$emit('update_date_obj', date_obj);
      this.$emit('update_format', this.date_format(date_obj));
      this.display_flg = false;
    },
    date_format (date_obj) {
      let result = this.format;
      let week_arr = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'];
      let set_year, set_month, set_date, set_week;
      set_year = date_obj.getFullYear();
      set_month = this.zero_pad(date_obj.getMonth() + 1);
      set_date = this.zero_pad(date_obj.getDate());
      set_week = this.$t('week.' + week_arr[date_obj.getDay()]);

      result = result.replace(/(YYYY)/, set_year);
      result = result.replace(/(MM)/, set_month);
      result = result.replace(/(DD)/, set_date);
      result = result.replace(/(W)/, set_week);

      return result;
    },
    date_format_yyyymmdd (date_obj) {
      let set_year, set_month, set_date;
      set_year = date_obj.getFullYear();
      set_month = date_obj.getMonth() + 1;
      set_date = date_obj.getDate();

      return String(set_year) +
        this.zero_pad(set_month) +
        this.zero_pad(set_date);
    },
    zero_pad (num) {
      return ('00' + String(num)).slice(-2);
    },
    schedule_get (check_date_obj) {
      let set_year, set_month, set_date;
      set_year = check_date_obj.getFullYear();
      set_month = check_date_obj.getMonth() + 1;
      set_date = check_date_obj.getDate();

      let select_ymd = String(set_year) +
        this.zero_pad(set_month) +
        this.zero_pad(set_date);
      if (this.schedules[select_ymd]) {
        return this.schedules[select_ymd]['num'];
      } else {
        return '';
      }
    },
    schedule_end (check_date_obj) {
      let set_year, set_month, set_date;
      set_year = check_date_obj.getFullYear();
      set_month = check_date_obj.getMonth() + 1;
      set_date = check_date_obj.getDate();

      let select_ymd = String(set_year) +
        this.zero_pad(set_month) +
        this.zero_pad(set_date);
      if (this.schedules[select_ymd]) {
        return this.schedules[select_ymd]['end'];
      } else {
        return false;
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.component-datepicker-calendar {
  width: 100%;
  height: 100%;
  background-color: #fff;
  border: 1px solid #f7f7f7;
  box-sizing: border-box;
  color: #2c3e50;
  -ms-user-select: none;
  -webkit-user-select: none;
  user-select: none;

  p.small-font-size-p {
    font-size: 0.75rem;
  }

  p.large-font-size-p {
    font-size: 1.1rem;
  }

  .header {
    display: flex;
    align-items: center;
    height: 8%;
    border-bottom: 1px solid #f7f7f7;
    box-sizing: border-box;

    p {
      text-align: center;
    }

    .calendar-button {
      width: 20%;
      cursor: pointer;
    }

    .calendar-button:hover {
      color: #0080ff;
      font-weight: bold;
    }

    .calendar-button[disabled] {
      opacity: 0.3;
      cursor: default;
      pointer-events: none;
    }

    .calendar-title {
      width: 60%;
    }

    .prev {
      background-image: url('./assets/prev_icon.svg');
      background-repeat: no-repeat;
      background-position: center;
      background-size: auto 100%;
      height: 100%;
    }

    .next {
      background-image: url('./assets/next_icon.svg');
      background-repeat: no-repeat;
      background-position: center;
      background-size: auto 100%;
      height: 100%;
    }
  }

  table {
    width: 100%;
    height: 92%;
    margin: 0;
    padding: 0;
    text-align: center;
    border-collapse: collapse;

    thead {
      text-align: center;
      font-size: 0.75rem;
      background-color: #fff;
      color: #333;
    }

    tbody {
      text-align: left;

      td {
        padding: 0;
        margin: 0;
        vertical-align: top;
        text-align: center;
        background-color: #ffffff;
        border-top: 1px solid #f7f7f7;
        border-right: 1px solid #f7f7f7;
        width: calc(100% / 7);
        height: calc(100% / 6);

        p.date {
          margin: 2px 0 0 0;
          padding: 0;
          width: auto;
          height: 20px;
          margin-right: 4px;
          font-size: 0.9rem;
          text-align: right;
          cursor: pointer;
        }

        p.date.today {
          color: #fff;
          background-color: #b95a3a;
          border-radius: 50%;
          width: 20px;
          display: flex;
          justify-content: center;
          align-items: center;
          margin-left: calc(100% - 22px);
        }
      }

      td.sat:not(.before-next-month) {
        background-color: #fcfcfc;

        p.date:not(.today) {
          color: #bababa;
        }
      }

      td.sun:not(.before-next-month),
      .holiday:not(.before-next-month) {
        background-color: #fcfcfc;

        p.date:not(.today) {
          color: #bababa;
        }
      }

      td.selected-date:not(.before-next-month) {
        background-color: #fffca5;
      }

      td:last-child {
        border-right: none;
      }

      td[disabled] {
        opacity: 0.3;
        cursor: default;
        pointer-events: none;
      }

      td.before-next-month {
        background-color: #eaeaea;
        p.date:not(.today) {
          color: #9e9e9e;
        }
      }

      td:not(.selected-date):hover {
        cursor: pointer;
      }

      td:not(.selected-date):active {
        background-color: #ebfbff;
        cursor: pointer;
      }

      .schedule-container {
        height: calc(100% - 16px);
        display: flex;
        justify-content: center;
        align-items: center;
      }

      p.schedule {
        margin: -6px 0 0 0;
        padding: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 0.75rem;
        width: 20px;
        height: 20px;
        color: #fff;
        cursor: pointer;
      }

      p.schedule.contain {
        background-color: #ff5e5e;
        border-radius: 50%;
      }

      p.schedule.contain.end {
        background-color: #6f6f6f;
      }
    }
  }
}

.calendar-absolute {
  position: absolute;
  z-index: 8100;
  box-shadow: 1px 1px 5px rgba(0, 0, 0, 0.1), -1px 0px 5px rgba(0, 0, 0, 0.1);
}

@media screen and (max-width:480px) {
  .calendar-absolute {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
  }
}
</style>
